import React, { useEffect, useState } from "react";
import AlertBox from "../../component/AlertBox";
import { Badge, LinearProgress, styled, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TabCompo from "../../component/TabCompo";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import DialogBox from "../../component/DialogBox";
import ButtonCompo from "../../component/ButtonCompo";
import InputField from "../../component/InputField";
import SelectField from "../../component/SelectField";
import dayjs from "dayjs";
import { DatePicker, StaticDatePicker } from "@mui/x-date-pickers";
import { ServerDay } from "../../component/utils/HighlightDates";

function GeneralLeaves() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [leaveData, setLeaveData] = useState([]);
  const [leaveTitle, setLeaveTitle] = useState("");
  const [leaveFor, setLeaveFor] = useState("");
  const [leaveTotalDays, setLeaveTotalDays] = useState(0);
  const [reload, setReload] = useState(false);
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeData !== null &&
      employeeData?.admin?.leaveManagement === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  // fetch leave structure
  async function getStructure() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/get`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setLeaveData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Leave structure fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // add leave
  async function addLeave() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/add`,
        method: "post",
        data: {
          title: leaveTitle,
          leaveFor: leaveFor,
          totalDays: leaveTotalDays,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Leave added");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // update leave
  async function updateLeave(data) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/update`,
        method: "put",
        data: {
          title: leaveTitle,
          leaveFor: leaveFor,
          totalDays: leaveTotalDays,
          leaveId: data?.leaveId,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Leave updated");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // delete leave
  async function deleteLeave(data) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/delete`,
        method: "delete",
        data: {
          leaveId: data?.leaveId,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Leave deleted");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // update leave accounts
  async function updateLeaveAccounts() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/update/leave/accounts`,
        method: "get",
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Leave accounts updated");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  function setValue(data) {
    setLeaveTitle(data?.title);
    setLeaveFor(data?.leaveFor);
    setLeaveTotalDays(data?.totalDays);
  }

  useEffect(() => {
    getStructure();
  }, [reload]);

  // "Leave For" select field data
  const leaveOptions = [
    {
      title: "Male",
      value: "Male",
    },
    {
      title: "Female",
      value: "Female",
    },
    {
      title: "All",
      value: "All",
    },
  ];

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-full">
          {leaveData?.length > 0 ? (
            <div className="w-full">
              <div className="w-full flex justify-end items-end">
                <ButtonCompo onClick={updateLeaveAccounts}>
                  Save Changes
                </ButtonCompo>
                <DialogBox
                  trigger={<ButtonCompo>Add Leave</ButtonCompo>}
                  title="Add New Leave"
                  actionButton={
                    <ButtonCompo onClick={addLeave}>Save</ButtonCompo>
                  }
                  closeActionButton={<ButtonCompo>Cancel</ButtonCompo>}
                >
                  <InputField
                    label="Title"
                    onChange={(e) => setLeaveTitle(e?.target?.value)}
                  />
                  <div className="flex justify-center items-center gap-3 mt-3">
                    <SelectField
                      label="Leave For"
                      value={leaveFor}
                      setValue={(e) => setLeaveFor(e?.target?.value)}
                      valueArray={leaveOptions}
                    />
                    <InputField
                      label="Total Days"
                      onChange={(e) => setLeaveTotalDays(e?.target?.value)}
                    />
                  </div>
                </DialogBox>
              </div>
              <div className="mt-5 w-full">
                {leaveData?.map((e, i) => (
                  <section
                    className={`flex w-full justify-between items-center border-b-[1px] mt-3 pb-3`}
                  >
                    <div>
                      <p className="font-medium text-[17px]">
                        {e?.title}{" "}
                        <span
                          className={`${
                            e?.leaveFor === "All"
                              ? "bg-green-100 text-green-800"
                              : e?.leaveFor === "Male"
                              ? "bg-blue-100 text-indigo-800"
                              : "bg-pink-100 text-pink-800"
                          } text-[13px] px-[10px] py-1 rounded-full text-green-800 font-medium ml-1`}
                        >
                          {e?.leaveFor}
                        </span>
                      </p>
                      <p className="text-[15px] text-slate-500 mt-1">
                        Total {e?.totalDays} days
                      </p>
                    </div>
                    <div className="flex justify-end items-center gap-3">
                      <DialogBox
                        trigger={
                          <ButtonCompo onClick={() => setValue(e)}>
                            Edit
                          </ButtonCompo>
                        }
                        title="Edit Leave"
                        actionButton={
                          <ButtonCompo onClick={() => updateLeave(e)}>
                            Update
                          </ButtonCompo>
                        }
                        closeActionButton="Cancel"
                      >
                        {e?.title !== "Paid Leave" ? (
                          <InputField
                            label="Title"
                            onChange={(e) => setLeaveTitle(e?.target?.value)}
                            value={leaveTitle}
                          />
                        ) : (
                          ""
                        )}
                        <div className="flex justify-center items-center gap-3 mt-3">
                          {e?.title !== "Paid Leave" ? (
                            <SelectField
                              label="Leave For"
                              value={leaveFor}
                              setValue={(e) => setLeaveFor(e?.target?.value)}
                              valueArray={leaveOptions}
                            />
                          ) : (
                            ""
                          )}
                          <InputField
                            label="Total Days"
                            onChange={(e) =>
                              setLeaveTotalDays(e?.target?.value)
                            }
                            value={leaveTotalDays}
                          />
                        </div>
                      </DialogBox>
                      <ButtonCompo
                        color={"error"}
                        onClick={(event) => deleteLeave(e)}
                      >
                        Delete
                      </ButtonCompo>
                    </div>
                  </section>
                ))}
              </div>
            </div>
          ) : (
            <div className="w-full flex justify-center items-center flex-col gap-5">
              <p className="text-center mt-10 font-medium text-slate-500">
                No Leave Is Added Yet
              </p>
              <DialogBox
                trigger={<ButtonCompo>Add Leave</ButtonCompo>}
                title="Add New Leave"
                actionButton={
                  <ButtonCompo onClick={addLeave}>Save</ButtonCompo>
                }
                closeActionButton={<ButtonCompo>Cancel</ButtonCompo>}
              >
                <InputField
                  label="Title"
                  onChange={(e) => setLeaveTitle(e?.target?.value)}
                />
                <div className="flex justify-center items-center gap-3 mt-3">
                  <SelectField
                    label="Leave For"
                    value={leaveFor}
                    setValue={(e) => setLeaveFor(e?.target?.value)}
                    valueArray={leaveOptions}
                  />
                  <InputField
                    label="Total Days"
                    onChange={(e) => setLeaveTotalDays(e?.target?.value)}
                  />
                </div>
              </DialogBox>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const NoActionButtons = () => null;

function HolidayLeaves() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [leaveData, setLeaveData] = useState([]);
  const [reload, setReload] = useState(false);
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [title, setTitle] = useState();
  const [totalDays, setTotalDays] = useState(0);
  const [selectedDate, setSelectedDate] = useState(dayjs());

  // fetch holidays
  async function getHolidays() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/holidays`,
        method: "get",
        withCredentials: true,
      });
      //console.log(res.data?.data);
      setLeaveData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Holidays fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // add leave
  async function addLeave() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/holiday/add`,
        method: "post",
        data: {
          description: title,
          startDate: startDate?.$d?.toString(),
          endDate: endDate?.$d?.toString(),
          totalDays: totalDays,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Holiday added");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
      setEndDate(dayjs());
      setStartDate(dayjs());
      setTotalDays(0);
    }
  }

  // edit holiday
  async function editHoliday(id) {
    console.log(startDate?.$d);
    console.log(endDate?.$d);
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/holiday/edit`,
        method: "put",
        data: {
          description: title,
          startDate: startDate?.$d?.toString(),
          endDate: endDate?.$d?.toString(),
          totalDays: totalDays,
          id: id,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Holiday edited");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
      setEndDate(dayjs());
      setStartDate(dayjs());
      setTotalDays(0);
    }
  }

  // delete leave
  async function deleteLeave(id) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/holiday/delete/${id}`,
        method: "delete",
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Holiday deleted");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getHolidays();
  }, [reload]);

  // console.log(startDate?.$d);
  // console.log(endDate?.$d);

  // calculating total days
  /* let me explain why I add 1 to days. 
    In general, we calcuate days like 1/1/2023 to 2/1/2023 is 1 day. 
    But here, in the leave structure, it assumed as 2 days like 
    you are on leave on 1 and 2 also. That's why we need to add 1.
  */
  useEffect(() => {
    const date1 = Date.UTC(startDate?.$y, startDate?.$M, startDate?.$D);
    const date2 = Date.UTC(endDate?.$y, endDate?.$M, endDate?.$D);

    // subtract
    const milisec = date2 - date1;

    // convert milisec to days
    const days = Math.floor(milisec / (1000 * 60 * 60 * 24)) + 1;

    if (days < 0) {
      setTotalDays(0);
    }

    setTotalDays(days);
  }, [startDate, endDate]);

  // highlighted dates
  let highlightedDays = [];

  // parsing dates from DB to a standard way to show in the calender as highlighted
  leaveData?.map((leave) => {
    // console.log(leave);

    let date;
    // if there is only 1 leave day
    if (leave?.totalDays === 1) {
      date = `${leave?.startYear}-${Number(Number(leave?.startMonth) + 1)
        ?.toString()
        .padStart(2, "0")}-${Number(leave?.startDom)
        ?.toString()
        ?.padStart(2, "0")}`;
      highlightedDays.push(date);
    } else {
      // if there is more than 1 leave day
      // make that dates to "Date" type
      let currentDate = dayjs(
        `${leave?.startYear}-${Number(Number(leave?.startMonth) + 1)
          ?.toString()
          .padStart(2, "0")}-${leave?.startDom}`
      );
      // I subtract 1 from date because the last date is not a leave day. THe work will be resumed from that day.
      let endDate = dayjs(
        `${leave?.endYear}-${Number(Number(leave?.endMonth) + 1)
          ?.toString()
          .padStart(2, "0")}-${Number(leave?.endDom)}`
      );

      // iterate
      while (currentDate <= endDate) {
        // push date
        highlightedDays.push(
          `${currentDate.$y}-${(Number(currentDate.$M) + 1)
            .toString()
            .padStart(2, 0)}-${Number(currentDate.$D)
            .toString()
            .padStart(2, "0")}`
        );
        //console.log(currentDate);
        // update date by 1 day
        currentDate = currentDate.add(1, "day");
      }
    }
  });

  // set edit value
  function setEditValue(data) {
    setTitle(data?.description);
    setStartDate(
      dayjs(
        `${data?.startYear}-${Number(data?.startMonth) + 1}-${Number(
          data?.startDom
        )}`
      )
    );
    setEndDate(
      dayjs(
        `${data?.endYear}-${Number(data?.endMonth) + 1}-${Number(data?.endDom)}`
      )
    );
    setTotalDays(data?.totalDays);
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div>
          {leaveData?.length > 0 ? (
            <div className="w-full">
              <div className="mt-5 flex justify-center items-center">
                <div className="w-[40rem]">
                  <StaticDatePicker
                    orientation="landscape"
                    value={dayjs()}
                    className="!w-full !grid !grid-cols-2"
                    slots={{
                      day: ServerDay,
                      actionBar: NoActionButtons,
                    }}
                    slotProps={{
                      day: {
                        highlightedDays,
                      },
                    }}
                    localeText={{
                      toolbarTitle: "Holiday Calender",
                    }}
                  />
                </div>
              </div>
              <div className="w-full mt-5 flex sm:hidden justify-center items-center">
                <StaticDatePicker
                  orientation="portrait"
                  value={dayjs()}
                  slots={{
                    day: ServerDay,
                    actionBar: NoActionButtons,
                  }}
                  slotProps={{
                    day: {
                      highlightedDays,
                    },
                  }}
                  localeText={{
                    toolbarTitle: "Holiday Calender",
                  }}
                />
              </div>
              <div className="mt-5 w-full flex justify-end items-end">
                <DialogBox
                  trigger={<ButtonCompo>Add Holiday</ButtonCompo>}
                  title="Add New Holiday"
                  actionButton={
                    <ButtonCompo onClick={addLeave}>Save</ButtonCompo>
                  }
                  closeActionButton={<ButtonCompo>Cancel</ButtonCompo>}
                  maxWidth="sm"
                >
                  <InputField
                    label="Title"
                    onChange={(e) => setTitle(e?.target?.value)}
                  />
                  <div className="grid grid-cols-3 gap-3 mt-3">
                    <DatePicker
                      onChange={(e) => setStartDate(e)}
                      label="From"
                    />
                    <DatePicker onChange={(e) => setEndDate(e)} label="To" />
                    <InputField label="Total Days" value={totalDays} readOnly />
                  </div>
                  {totalDays > 0 ? (
                    ""
                  ) : (
                    <p className="mt-3 text-red-600">
                      * Please select valid dates
                    </p>
                  )}
                </DialogBox>
              </div>
              <div className="w-full">
                {leaveData?.map((e, i) => (
                  <section className="flex justify-between items-center border-b-[1px] pb-3 mt-5">
                    <div>
                      <p className="text-[17px] font-medium">
                        {e?.description}{" "}
                        <span className="ml-1 text-[13px] bg-slate-200/80 px-2 py-1 rounded-full text-slate-700 font-medium">
                          {e?.totalDays > 1
                            ? `${e?.totalDays} days`
                            : `${e?.totalDays} day`}
                        </span>
                      </p>
                      <p className="text-[14px] text-slate-500 mt-2 font-medium">
                        {e?.totalDays > 1
                          ? `${e?.startDom?.toString()?.padStart(2, "0")}-${(
                              Number(e?.startMonth) + 1
                            )
                              ?.toString()
                              ?.padStart(2, "0")}-${e?.startYear} to ${e?.endDom
                              ?.toString()
                              ?.padStart(2, "0")}-${(Number(e?.endMonth) + 1)
                              ?.toString()
                              ?.padStart(2, "0")}-${e?.endYear}`
                          : `${e?.startDom?.toString()?.padStart(2, "0")}-${(
                              Number(e?.startMonth) + 1
                            )
                              ?.toString()
                              ?.padStart(2, "0")}-${e?.startYear}`}
                      </p>
                    </div>
                    <div className="flex justify-center items-center gap-2">
                      <DialogBox
                        trigger={
                          <ButtonCompo onClick={(event) => setEditValue(e)}>
                            Edit
                          </ButtonCompo>
                        }
                        title="Add New Holiday"
                        actionButton={
                          <ButtonCompo onClick={(event) => editHoliday(e)}>
                            Save
                          </ButtonCompo>
                        }
                        closeActionButton={<ButtonCompo>Cancel</ButtonCompo>}
                        maxWidth="sm"
                      >
                        <InputField
                          label="Title"
                          onChange={(e) => setTitle(e?.target?.value)}
                          value={title}
                        />
                        <div className="grid grid-cols-3 gap-3 mt-3">
                          <DatePicker
                            onChange={(e) => setStartDate(e)}
                            label="From"
                            value={startDate}
                          />
                          <DatePicker
                            onChange={(e) => setEndDate(e)}
                            label="To"
                            value={endDate}
                          />
                          <InputField
                            label="Total Days"
                            value={totalDays}
                            readOnly
                          />
                        </div>
                        {totalDays > 0 ? (
                          ""
                        ) : (
                          <p className="mt-3 text-red-600">
                            * Please select valid dates
                          </p>
                        )}
                      </DialogBox>
                      <ButtonCompo
                        color={"error"}
                        onClick={(event) => deleteLeave(e?._id)}
                      >
                        Delete
                      </ButtonCompo>
                    </div>
                  </section>
                ))}
              </div>
            </div>
          ) : (
            <div className="w-full flex flex-col gap-3 justify-center items-center">
              <p className="mt-10 text-slate-500 font-medium">
                No Holidays Added Yet
              </p>
              <DialogBox
                trigger={<ButtonCompo>Add Leave</ButtonCompo>}
                title="Add New Holiday"
                actionButton={
                  <ButtonCompo onClick={addLeave}>Save</ButtonCompo>
                }
                closeActionButton={<ButtonCompo>Cancel</ButtonCompo>}
                maxWidth="sm"
              >
                <InputField
                  label="Title"
                  onChange={(e) => setTitle(e?.target?.value)}
                />
                <div className="grid grid-cols-3 gap-3 mt-3">
                  <DatePicker onChange={(e) => setStartDate(e)} label="From" />
                  <DatePicker onChange={(e) => setEndDate(e)} label="To" />
                  <InputField label="Total Days" value={totalDays} readOnly />
                </div>
                {totalDays > 0 ? (
                  ""
                ) : (
                  <p className="mt-3 text-red-600">
                    * Please select valid dates
                  </p>
                )}
              </DialogBox>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function WeeklyHolidays() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [holidayData, setHolidayData] = useState([]);
  const [daysOfWeek, setDaysOfWeek] = useState([
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ]);
  const [selectedHolidays, setSelectedHolidays] = useState([]);
  const [copyHolidaysArr, setCopyHolidaysArray] = useState([]);
  const [reload, setReload] = useState(false);

  async function getCompanyData() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/company/data`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setHolidayData(res.data?.data?.weeklyHolidays || []);
      const rawData = res.data?.data?.weeklyHolidays
      let names = []
      if(Array.isArray(rawData) && rawData?.length > 0) {
        rawData.map((data, i) => {
          names.push(data?.name)
        })
      }
      setCopyHolidaysArray(names)
      setSelectedHolidays(rawData)
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  async function updateWeeklyHolidays() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/update/weekly/holiday`,
        method: "put",
        data: {
          weeklyHolidayArray: selectedHolidays,
        },
        withCredentials: true,
      });
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Weekly holiday has been changed");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Weekly holiday change failed");
    } finally {
      setLoading(false);
    }
  }

  function addDayToArray(day, index) {
    const obj = {
      dayIndex: index,
      name: day,
    };

    // check the day is already in the or not
    if (copyHolidaysArr.includes(day)) {
      // remove the day if already present
      setSelectedHolidays((prev) => prev.filter((data) => data.name !== day));
      setCopyHolidaysArray((prev) => prev.filter((data) => data !== day));
    } else {
      // add the day if not present
      setSelectedHolidays((prev) => [...prev, obj]);
      setCopyHolidaysArray((prev) => [...prev, day]);
    }
  }

  console.log(holidayData);

  useEffect(() => {
    getCompanyData();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <div>
            <section className="flex justify-end">
              <DialogBox
                trigger={
                  <ButtonCompo variant={"contained"}>Edit Holiday</ButtonCompo>
                }
                actionButton={
                  <ButtonCompo onClick={updateWeeklyHolidays}>
                    Save Changes
                  </ButtonCompo>
                }
                title="Add Weekly Holiday"
              >
                <div>
                  <div className="grid grid-cols-3 gap-3">
                    {daysOfWeek.map((day, i) => (
                      <ButtonCompo
                        variant={
                          copyHolidaysArr.includes(day)
                            ? "contained"
                            : "outlined"
                        }
                        onClick={() => addDayToArray(day, i)}
                      >
                        {day}
                      </ButtonCompo>
                    ))}
                  </div>
                </div>
              </DialogBox>
            </section>
            {holidayData.length === 0 ? (
              <div>
                <p className="text-center text-slate-500 font-medium">
                  No weekly holiday found
                </p>
              </div>
            ) : (
              <div className="flex items-center justify-start gap-3">
                {holidayData.map((data, i) => (
                  <section className="bg-blue-100 px-3 py-1 text-blue-600 font-medium rounded-md">{data?.name}</section>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function LeaveManagement() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeData !== null &&
      employeeData?.admin?.leaveManagement === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const tabArray = [
    {
      title: "General Leaves",
      component: <GeneralLeaves />,
    },
    {
      title: "Holiday Leaves",
      component: <HolidayLeaves />,
    },
    {
      title: "Weekly Holidays",
      component: <WeeklyHolidays />,
    },
  ];

  return (
    <>
      <div className="w-full flex justify-center items-center">
        <div className="w-[90vw]  py-5">
          <h1 className="text-[20px] sm:text-[30px] font-medium text-left w-full">
            Leave Management
          </h1>
          <div className="mt-5 w-full">
            <TabCompo tabArray={tabArray} />
          </div>
        </div>
      </div>
    </>
  );
}

export default LeaveManagement;
